// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1k67r","inputWrap":"styles_inputWrap__3sppq","input":"styles_input__2BvlJ"};